import { render, staticRenderFns } from "./Recyclable.vue?vue&type=template&id=0feecec0&"
import script from "./Recyclable.vue?vue&type=script&lang=js&"
export * from "./Recyclable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports